import { localStorageGetItem, localStorageSetItem } from 'entrypoints/storage_helpers';

const STORAGE_KEY = 'HomepageSurveyAnswers';

function getNewExpireTime() {
  const validDays = 14;
  const now = Date.now(); // In ms

  // Has to convert to valid days to ms
  return now + validDays * 24 * 60 * 60 * 1000;
}

export function clearAnswersInStorage() {
  localStorageSetItem(STORAGE_KEY, JSON.stringify({}));
}

function resetAnswer() {
  const sessionAnswers = {
    wasReset: true,
  };
  localStorageSetItem(STORAGE_KEY, JSON.stringify(sessionAnswers));
  return sessionAnswers;
}

export function getAnswersFromStorage() {
  const sessionAnswers = localStorageGetItem(STORAGE_KEY);
  if (!sessionAnswers) {
    return {};
  }

  const parsedSessionAnswers = JSON.parse(sessionAnswers);

  // If answer has expires, clear storage
  if (parsedSessionAnswers.expireTime && parsedSessionAnswers.expireTime < Date.now()) {
    return resetAnswer();
  }

  return parsedSessionAnswers;
}

export function storeAnswerToStorage(key, val) {
  const currentSessionAnswers = getAnswersFromStorage();
  currentSessionAnswers[key] = val;
  currentSessionAnswers.expireTime = getNewExpireTime();
  localStorageSetItem(STORAGE_KEY, JSON.stringify(currentSessionAnswers));
}
